module.exports = __webpack_public_path__ + "static/img/news9.e644fbd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news4/news9.jpg
// module id = 6BNT
// module chunks = 1